import React, { useMemo } from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';

export default function GTDRCommonService(props: any) {
  const {
    style,
    className,
    api,
    dataKey = 'riskLevelData',
    filterValue,
    filterLoading,
    gameCode,
    studioCode,
    children,
    extraParams = {},
    latestVersionObj,
    ...resetProps
  } = props || {};

  const data = useMemo(
    () => ({
      gameCode,
      studioCode,
      // 多层数据挂载
      ...(extraParams || {}),
    }),
    [gameCode, studioCode, extraParams],
  );

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        filterVal={filterValue}
        filterLoading={filterLoading}
        trackData={['gameCode', 'studioCode']}
        beforeRequest={(data) => {
          const { filterVal, gameCode, studioCode } = data;

          const { version = [] } = filterVal || {};

          let currentVersion = version?.[0] || '';
          // 优先取latest version没有的话则取第一个
          if (version?.includes(latestVersionObj?.version)) {
            currentVersion = latestVersionObj.version;
          }

          const params = {
            game_code: gameCode,
            version_list: [currentVersion],
            studio_code: studioCode,
            ...extraParams,
          };
          return params;
        }}
      >
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...resetProps,
            gameCode,
            filterValue,
          }),
        )}
      </Service>
    </div>
  );
}
